import { makeStyles } from 'tss-react/mui';
import {
  COMBINATION_GRID_GAP_WIDTH,
  COMBINATION_PRICE_GAP_WIDTH,
} from '../../../consts/combinationLine.consts';

interface UseStylesProps {
  infoWidth: number;
  infoMaxWidth: number;
  gridMinWidth: number;
}

export const useCombinationLineDesktopStyles = makeStyles<UseStylesProps>()(
  (_theme, { infoWidth, infoMaxWidth, gridMinWidth }) => ({
    info: {
      width: infoWidth,
      maxWidth: infoMaxWidth,
      minWidth: 0,
    },
    grid: {
      flex: '1 1 0%',
      minWidth: gridMinWidth,
      marginLeft: COMBINATION_GRID_GAP_WIDTH,
      overflow: 'auto',
    },
    price: {
      flexShrink: 0,
      marginLeft: COMBINATION_PRICE_GAP_WIDTH,
    },
  }),
);
